import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import { toWords } from "number-to-words";
import { useLocation, useNavigate } from "react-router-dom";

function UpdateReleased() {
  const { state } = useLocation();
  const [id, setId] = useState(() => state?.id || "");
  const [ott, setOtt] = useState([]);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [ready, setReady] = useState([]);

  const [loading, setLoading] = useState(true);
  const [released, setReleased] = useState({
    contentType: "",
    language: [],
    projectName: "",
    genre: "",
    lease: "",
    exclusiveRights: "",
    nonExclusiveRights: "",
    contentDescription: "",
    trailer: "",
    trailerPassword: "",
    bannerName: "",
    productionHouseName: "",
    producer_investor: "",
    director: "",
    creativeDirector: "",
    writer: "",
    dop: "",
    budget: 0,
    ottId: "",
  });

  // Handle input change for new project form
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setReleased((prevProject) => ({
      ...prevProject,
      [name]: name === "budget" ? parseFloat(value) || 0 : value,
    }));
  }, []);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setReleased((prevProject) => ({
      ...prevProject,
      [name]: files.length > 1 ? [...files] : files[0],
    }));
  };

  // Fetch projects from the API when the component loads
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          `http://fundoramaa.co.in//api/v1/content/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        const project = response.data?.data;
        if (project && typeof project === "object") {
          setReady([project]); // If you still want to keep this for some reason
          setReleased((prev) => ({
            ...prev,
            ...project,
          }));
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [id]);

  // Handle form input changes, including checkboxes and text fields
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setReleased((prevData) => ({
        ...prevData,
        [name]: checked
          ? [...prevData[name], value] // Add the checkbox value if checked
          : prevData[name].filter((item) => item !== value), // Remove it if unchecked
      }));
    } else {
      setReleased((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleUpdateProject = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create FormData object to append both files and other project data
    const formData = new FormData();

    // Append non-file fields
    formData.append("contentType", released.contentType);
    formData.append("language", released.language);
    formData.append("projectName", released.projectName);
    formData.append("genre", released.genre);
    formData.append("lease", released.lease);
    formData.append("exclusiveRights", released.exclusiveRights);
    formData.append("nonExclusiveRights", released.nonExclusiveRights);
    formData.append("contentDescription", released.contentDescription);
    formData.append("trailer", released.trailer);
    formData.append("trailerPassword", released.trailerPassword);
    formData.append("bannerName", released.bannerName);
    formData.append("productionHouseName", released.productionHouseName);
    formData.append("producer_investor", released.producer_investor);
    formData.append("director", released.director);
    formData.append("creativeDirector", released.creativeDirector);
    formData.append("writer", released.writer);
    formData.append("dop", released.dop);
    formData.append("budget", released.budget);
    formData.append("ottId", released.ottId);

    // Append files to FormData
    if (released.poster) {
      formData.append("poster", released.poster);
    }
    if (released.projectDeclaration) {
      formData.append("projectDeclaration", released.projectDeclaration);
    }
    if (released.contract_agreement) {
      formData.append("contract_agreement", released.contract_agreement);
    }
    if (released.noticeLegal) {
      formData.append("noticeLegal", released.noticeLegal);
    }

    try {
      const response = await axios.put(
        `http://fundoramaa.co.in//api/v1/content/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data?.data) {
        setReady((prevProjects) => [...prevProjects, response.data.data]);
        setIsSubmitting(false);
        navigate(-1);
      } else {
        console.error("Unexpected response format:", response.data);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error adding project:", error);
      setIsSubmitting(false);
    }
  };

  // Fetch OTT from the API
  useEffect(() => {
    const fetchOtt = async () => {
      try {
        const response = await axios.get(
          "http://fundoramaa.co.in//api/v1/ott/"
        );
        if (response.data && Array.isArray(response.data.data)) {
          setOtt(response.data.data);
        } else {
          console.error("Unexpected response format:", response.data);
          setOtt([]);
        }
      } catch (error) {
        console.error("Error fetching otts:", error);
        setOtt([]);
      } finally {
        setLoading(false);
      }
    };
    fetchOtt();
  }, []);

  useEffect(() => {
    console.log("OTT ID Loaded:", released.ottId);
  }, [released.ottId]);

  return (
    <>
      <div className="container">
        <div className="py-3">
          <div className="rounded-4">
            <div className="">
              <form onSubmit={handleUpdateProject}>
                <div className="py-2">
                  <div className="mb-3">
                    <span
                      onClick={() => window.history.back()}
                      class="back-button cursor-pointer"
                    >
                      <i className="bi bi-arrow-left h2"></i>
                    </span>
                    <div>
                      <h3 className="mb-0 lh-1">
                        <span className="text-reset">
                          {ready[0]?.projectName}
                        </span>
                      </h3>
                      <p className="m-0 text-capitalize">
                        {ready[0]?.bannerName}
                      </p>
                      <span
                        class={`badge px-4 mt-2 ${
                          ready[0]?.ottUpdates === "approved"
                            ? "bg-success-soft"
                            : "bg-danger-soft"
                        } mb-2 text-capitalize`}
                      >
                        {ready[0]?.ottUpdates}
                      </span>
                    </div>
                  </div>

                  <div>
                    <div className="mb-3">
                      <p className="text-dark mb-1 bg-light py-2 text-center rounded-pill">
                        Content Type Selection
                      </p>
                    </div>
                    <div className="row g-3">
                      <div className="col-lg-6 col-12">
                        <label>
                          Select your type of content{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control mt-1"
                          name="contentType"
                          value={released.contentType}
                          onChange={handleInputChange}
                          required
                          autoComplete="off"
                        >
                          <option value="">Select</option>
                          <option value="tvshow">TV Show</option>
                          <option value="webseries">Web Series</option>
                          <option value="movie">Movie</option>
                          <option value="shortfilm">Short Film</option>
                        </select>
                      </div>
                      <div className="col-lg-6 col-12">
                        <label>
                          Select language <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control mt-1"
                          name="language"
                          value={released.language}
                          onChange={handleInputChange}
                          required
                          autoComplete="off"
                        >
                          <option value="">Select</option>
                          <option value="hindi">Hindi</option>
                          <option value="bengali">Bengali</option>
                          <option value="marathi">Marathi</option>
                          <option value="telugu">Telugu</option>
                          <option value="tamil">Tamil</option>
                          <option value="gujarati">Gujarati</option>
                          <option value="bhojpuri">Bhojpuri</option>
                          <option value="rajasthani">Rajasthani</option>
                          <option value="chhattisgarhi">Chhattisgarhi</option>
                          <option value="magahi">Magahi</option>
                          <option value="haryanvi">Haryanvi</option>
                          <option value="khortha/khotta">Khortha/Khotta</option>
                          <option value="marwari">Marwari</option>
                          <option value="bundeli/bundel khandi">
                            Bundeli/Bundel khandi
                          </option>
                          <option value="malvi">Malvi</option>
                          <option value="sadan/sadri">Sadan/Sadri</option>
                          <option value="mewari">Mewari</option>
                          <option value="awadhi">Awadhi</option>
                          <option value="lamani/lambadi">Lamani/Lambadi</option>
                          <option value="konkani">Konkani</option>
                          <option value="kurukh/oraon">Kurukh/Oraon</option>
                          <option value="tulu">Tulu</option>
                          <option value="manipuri">Manipuri</option>
                          <option value="sindhi">Sindhi</option>
                          <option value="pahari">Pahari</option>
                          <option value="hara/harauti">Hara/Harauti</option>
                          <option value="bagheli/baghel khandi">
                            Bagheli/Baghel Khandi
                          </option>
                          <option value="garhwali">Garhwali</option>
                          <option value="nimadi">Nimadi</option>
                          <option value="surjapuri">Surjapuri</option>
                          <option value="kumauni">Kumauni</option>
                          <option value="surgujia">Surgujia</option>
                          <option value="banjari">Banjari</option>
                          <option value="brajbhasha">Brajbhasha</option>
                          <option value="dhundhari">Dhundhari</option>
                          <option value="gojri/gujjari/gujar">
                            Gojri/Gujjari/Gujar
                          </option>
                          <option value="kangri">Kangri</option>
                          <option value="ahirani">Ahirani</option>
                          <option value="sambalpuri">Sambalpuri</option>
                          <option value="bagri">Bagri</option>
                          <option value="kachchhi">Kachchhi</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="pt-4">
                      <p className="text-dark mb-1 bg-light py-2 text-center rounded-pill">
                        Project Details
                      </p>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Enter your project name{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="projectName"
                        value={released.projectName}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Select Genre <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        name="genre"
                        value={released.genre}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="Mystery Thriller">
                          Mystery Thriller
                        </option>
                        <option value="Historical Fiction">
                          Historical Fiction
                        </option>
                        <option value="Drama">Drama</option>
                        <option value="Mystery">Mystery</option>
                        <option value="Suspense">Suspense</option>
                        <option value="Action Adventures">
                          Action Adventures
                        </option>
                        <option value="Fantasy">Fantasy</option>
                        <option value="Romance">Romance</option>
                        <option value="Science Fiction">Science Fiction</option>
                        <option value="Relationship Fiction">
                          Relationship Fiction
                        </option>
                        <option value="Comedy">Comedy</option>
                        <option value="Love Story">Love Story</option>
                        <option value="Horror">Horror</option>
                        <option value="Crime">Crime</option>
                      </select>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>Select Lease</label>
                      <select
                        className="form-control mt-1"
                        name="lease"
                        value={released.lease}
                        onChange={handleInputChange}
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="1 Year">1 Year</option>
                        <option value="2 Years">2 Years</option>
                        <option value="3 Years">3 Years</option>
                        <option value="4 Years">4 Years</option>
                        <option value="5 Years">5 Years</option>
                        <option value="6 Years">6 Years</option>
                        <option value="7 Years">7 Years</option>
                        <option value="8 Years">8 Years</option>
                        <option value="9 Years">9 Years</option>
                        <option value="10 Years">10 Years</option>
                      </select>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>Select Exclusive Rights</label>
                      <select
                        className="form-control mt-1"
                        name="exclusiveRights"
                        value={released.exclusiveRights}
                        onChange={handleInputChange}
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="1 Year">1 Year</option>
                        <option value="2 Years">2 Years</option>
                        <option value="3 Years">3 Years</option>
                        <option value="4 Years">4 Years</option>
                        <option value="5 Years">5 Years</option>
                        <option value="6 Years">6 Years</option>
                        <option value="7 Years">7 Years</option>
                        <option value="8 Years">8 Years</option>
                        <option value="9 Years">9 Years</option>
                        <option value="10 Years">10 Years</option>
                      </select>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>Select Non-Exclusive Rights</label>
                      <select
                        className="form-control mt-1"
                        name="nonExclusiveRights"
                        value={released.nonExclusiveRights}
                        onChange={handleInputChange}
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="1 Year">1 Year</option>
                        <option value="2 Years">2 Years</option>
                        <option value="3 Years">3 Years</option>
                        <option value="4 Years">4 Years</option>
                        <option value="5 Years">5 Years</option>
                        <option value="6 Years">6 Years</option>
                        <option value="7 Years">7 Years</option>
                        <option value="8 Years">8 Years</option>
                        <option value="9 Years">9 Years</option>
                        <option value="10 Years">10 Years</option>
                      </select>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Upload Poster{" "}
                        <span className="text-danger">(JPG, JPEG, PNG)</span>{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        name="poster"
                        onChange={handleFileChange}
                        className="form-control mt-1"
                        autoComplete="off"
                        accept=".jpg, .jpeg, .png"
                      />
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="pt-4">
                      <p className="text-dark mb-1 bg-light py-2 text-center rounded-pill">
                        Form Fields for Content Submission
                      </p>
                    </div>
                    <div className="col-12">
                      <label>
                        Content Descriptions (Story Line / Conclusion){" "}
                        <span className="text-danger">(500 Words)</span>{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <textarea
                        rows="5"
                        className="form-control mt-1"
                        name="contentDescription"
                        value={released.contentDescription}
                        onChange={handleInputChange}
                        autoComplete="off"
                        required
                      ></textarea>
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Trailer / Teaser (URL){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="url"
                        className="form-control mt-1"
                        name="trailer"
                        value={released.trailer}
                        onChange={handleInputChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Trailer / Teaser (Password){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control mt-1"
                        name="trailerPassword"
                        value={released.trailerPassword}
                        onChange={handleInputChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Banner Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="bannerName"
                        value={released.bannerName}
                        onChange={handleInputChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Production House Name{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="productionHouseName"
                        value={released.productionHouseName}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Producer / Investor{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="producer_investor"
                        value={released.producer_investor}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Director <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="director"
                        value={released.director}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Creative Director <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="creativeDirector"
                        value={released.creativeDirector}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Writer <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="writer"
                        value={released.writer}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Director of Photography (DOP){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="dop"
                        value={released.dop}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Project Declaration{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control mt-1"
                        placeholder=""
                        name="projectDeclaration"
                        onChange={handleFileChange}
                        autoComplete="off"
                        accept=".jpg, .jpeg, .png, .pdf, .docx"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Upload Contract / Agreement{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control mt-1"
                        placeholder=""
                        name="contract_agreement"
                        onChange={handleFileChange}
                        autoComplete="off"
                        accept=".jpg, .jpeg, .png, .pdf, .docx"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Notice & Legal <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control mt-1"
                        placeholder=""
                        name="noticeLegal"
                        onChange={handleFileChange}
                        autoComplete="off"
                        accept=".jpg, .jpeg, .png, .pdf, .docx"
                      ></input>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Budget <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="budget"
                        value={released.budget}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                        maxLength={10}
                      />
                      {released.budget > 0 && (
                        <div>
                          <p className="text-capitalize mb-0 text-dark mt-2">
                            ({toWords(released.budget)})
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Select OTT Platform{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        name="ottId"
                        value={released.ottId?._id || released.ottId}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          setReleased((prevData) => ({
                            ...prevData,
                            ottId: selectedId,
                          }));
                        }}
                        required
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        {ott.map((platform) => (
                          <option key={platform._id} value={platform._id}>
                            {platform.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="col-6">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg mt-5 mb-2 w-100 rounded-3 fs-5 text-white"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Updating ..." : "Update"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateReleased;
